import { FormHelperText, Grid, Typography } from '@mui/material'
import React from 'react'
import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import YouTubeIcon from '@mui/icons-material/YouTube'
import TwitterIcon from '@mui/icons-material/Twitter'
import { ControlledCheckbox } from '../ControlledCheckbox'
import { TikTokIcon } from '../Icons/TikTokIcon'
import { useFormContext, get } from 'react-hook-form'
import { ControlledHiddenField } from '../ControlledHiddenField'

export const PlatformCheckboxes = ({ initialValues = {} }) => {
  const { formState, watch } = useFormContext()
  const error = get(formState.errors, 'platforms')
  const platformsValue = watch('platforms', initialValues)

  return (
    <>
      <ControlledHiddenField name='platforms' />
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Typography variant='body1' style={{ paddingBottom: 8 }}>
            Platforms
          </Typography>
        </Grid>
        <Grid item>
          <ControlledCheckbox
            name={`platforms.fb`}
            label={<FacebookIcon fontSize='large' />}
            checked={platformsValue.fb ?? false}
          />
        </Grid>
        <Grid item>
          <ControlledCheckbox
            name={`platforms.ig`}
            label={<InstagramIcon fontSize='large' />}
            checked={platformsValue.ig ?? false}
          />
        </Grid>
        <Grid item>
          <ControlledCheckbox
            name={`platforms.yt`}
            label={<YouTubeIcon fontSize='large' />}
            checked={platformsValue.yt ?? false}
          />
        </Grid>
        <Grid item>
          <ControlledCheckbox
            name={`platforms.tiktok`}
            label={<TikTokIcon fontSize='large' />}
            checked={platformsValue.tiktok ?? false}
          />
        </Grid>
        <Grid item>
          <ControlledCheckbox
            name={`platforms.twitter`}
            label={<TwitterIcon fontSize='large' />}
            checked={platformsValue.twitter ?? false}
          />
        </Grid>
      </Grid>
      {error?.message !== undefined && (
        <FormHelperText
          id={`error-helper-text-verticals`}
          error
          style={{ textAlign: 'left', paddingRight: 8 }}
        >
          {error?.message}
        </FormHelperText>
      )}
    </>
  )
}
